var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGoShieldLock = function SvgIconGoShieldLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#092b49",
    d: "M11.5 1.1c.4-.1.7-.1 1.1 0l8.3 2.7c.7.2 1.2.9 1.2 1.7v5c0 6.2-3.8 10.7-9.4 12.8q-.6.15-1.2 0c-5.6-2.1-9.4-6.6-9.4-12.8v-5c0-.8.5-1.4 1.2-1.7zm.6 1.5h-.2L3.7 5.2c-.1 0-.2.1-.2.2v5c0 5.5 3.3 9.5 8.4 11.4h.1c5.2-1.9 8.4-6 8.4-11.4v-5c0-.1 0-.2-.2-.2L12 2.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#30b7fd",
    d: "M13 12.2V15c0 .6-.4 1-1 1s-1-.4-1-1v-2.8c-1-.6-1.3-1.8-.7-2.7.6-1 1.8-1.3 2.7-.7 1 .6 1.3 1.8.7 2.7-.2.3-.4.6-.7.7"
  })));
};
export default SvgIconGoShieldLock;